var render = function render() {
  var _this = this;

  var _vm = this,
      _c = _vm._self._c;return _c('el-form', { ref: "deliver-form", attrs: { "model": _vm.deliver } }, [_c('el-row', { attrs: { "gutter": 20 } }, [_c('el-col', { attrs: { "span": 12 } }, [_c('el-form-item', _vm._b({}, 'el-form-item', _vm.formItemList.path, false), [_c('creation-uploader', { attrs: { "on-success": _vm.onUploadSuccess, "on-change": _vm.onFileChange, "on-remove": _vm.onFileRemove, "file-list": _vm.fileList } })], 1)], 1), _vm._v(" "), _c('el-col', { attrs: { "span": 12 } }, [_c('el-form-item', _vm._b({}, 'el-form-item', _vm.formItemList.name, false), [_c('el-input', _vm._b({ model: { value: _vm.deliver.name, callback: function callback($$v) {
        _vm.$set(_vm.deliver, "name", $$v);
      }, expression: "deliver.name" } }, 'el-input', _vm.formItemList.name.params, false))], 1), _vm._v(" "), _vm.isVideoFile && _vm.isGameByAppCatId ? _c('feature-tag-config', { ref: "featureTagForm", attrs: { "form-config": _vm.formConfig, "scheme-value": _vm.schemeValue, "updateFeatureTag": _vm.updateFeatureTag, "updateSceneNum": _vm.updateSceneNum, "autoCompleteTag": _vm.copyTag, "autoScene": _vm.copyScene, "customButton": {
        label: '当前特征标签应用于需求下所有视频',
        callback: function callback() {
          _this.$confirm('将当前特征标签应用到需求下所有视频，是否继续？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            _vm.handleCopyTag(_vm.deliver);
          }).catch(function () {});
        }
      } } }) : _vm._e()], 1)], 1)], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };